import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { animateStepperNumersColor, animateStepperNumbers } from './StepperAnimation';
import './stepper.css';

const Stepper = ({separator, children, title }) => {
	const stepperItemsRef = useRef([]);
	const separatorsRef = useRef([]);
	const steps = React.Children.toArray(children).filter(child => child.props && child.props.title);

	useEffect(() => {
		animateStepperNumbers(stepperItemsRef, separatorsRef);
	}, [steps]);

	const renderedSteps = steps.map((child, index) => {
		const number = index + 1;
		return (
			<React.Fragment key={number}>
				<div className="StepperItem" ref={el => (stepperItemsRef.current[index] = el)}>
					<div className="number">
						<h2 className="material-symbols-outlined stepper-number">task_alt</h2>
					</div>
					{React.cloneElement(child, { number })}
				</div>
				{index < steps.length - 1 && 
					React.cloneElement(separator, {
						ref: el => (separatorsRef.current[index] = el)
					})
				}
			</React.Fragment>
		);
	});

	return (
		<div className="Stepper">
			{title && <h5 className="StepperMainTitle">{title}</h5>}
			{renderedSteps}
		</div>
	);
};

Stepper.Item = ({ title, description }) => (
	<div className="StepContent">
		<h3 className="StepperTitle">{title}</h3>
		{description && <p className="StepperDescription">{description}</p>}
	</div>
);

Stepper.propTypes = {
	children: PropTypes.node.isRequired,
	separator: PropTypes.node,
	title: PropTypes.string,
};

Stepper.defaultProps = {
	separator: <div className="StepSeparator" />,
	title: null,
};

Stepper.Item.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string,
};

Stepper.Item.defaultProps = {
	description: null,
};

export default Stepper;
